import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bef50ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "subtype" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "uploader" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { class: "phone" }
const _hoisted_12 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.yjfk'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('me.fklex')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({
            'background-color': item.id == $setup.typeid ? '#0D0D0D' : '#f8f8f8',
            'color': item.id == $setup.typeid ? '#fff' : '#0D0D0D'
        }),
          onClick: ($event: any) => ($setup.changeType(index))
        }, _toDisplayString(item.name), 13 /* TEXT, STYLE, PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('me.fknr')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            modelValue: $setup.inputtext,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (($setup.inputtext) = $event)),
              $setup.checkText
            ],
            rows: "3",
            autosize: "",
            type: "textarea",
            maxlength: "140",
            placeholder: $setup.t('me.qsrnyfk'),
            "show-word-limit": ""
          }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('me.addimg')) + " ", 1 /* TEXT */),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('me.zdyz')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_van_uploader, {
        "before-read": $setup.beforeRead,
        "max-size": 1000 * 1024,
        onOversize: $setup.onOversize,
        modelValue: $setup.fileList,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.fileList) = $event)),
        "after-read": $setup.afterRead,
        multiple: "",
        "max-count": 1
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createTextVNode(_toDisplayString(_ctx.$t('me.phone')), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('me.fkcgprd')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_van_field, {
        modelValue: $setup.tel,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => (($setup.tel) = $event)),
          $setup.checkText
        ],
        type: "tel",
        placeholder: $setup.t('me.inputphone'),
        style: {"background-color":"#fff"}
      }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_van_button, {
        color: $setup.btnok ? $setup.primaryColor : '#ECECEC',
        round: "",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.subok())),
        size: "large"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('me.submit')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["color"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}